import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';
import { PlusConfig } from '../environments/plus-enviroment';
import { RequestQueueService, QueueRequestArgs } from './request-queue.service';
import { ServiceLocator } from '../ServiceLocator';
import { Store } from '@ngrx/store';
import { TokenResponseModel, AppState, ServicePlus, PlusException } from '../models';
import { ClearLoggedUserAction, SaveLoggedUserAction } from '../store';
import { Router } from '@angular/router';


declare var $: any;

@Injectable()
export class HttpService {

  public static readonly ENDPOINT: string = PlusConfig.API.ENDPOINT;
  public static readonly APIKEY: string = PlusConfig.API.APIKEY;
  public static readonly UIL: string = '/uil1';
  private isRefreshing: boolean = false;
  public useApikey = false;
  // private http;
  private spinnerService;
  private requestQueueService;
  private token: TokenResponseModel;

  constructor(private http: HttpClient, private loggedUserStore: Store<AppState>, readonly router: Router) {
    this.spinnerService = ServiceLocator.injector.get(SpinnerService);
    this.requestQueueService = ServiceLocator.injector.get(RequestQueueService);
    this.loggedUserStore.select(store => store).subscribe((state: any) => {
      let x = state.loggedUser;
      if (x) {
        this.token = x;
      } else {
        this.token = null;
      }
    });
  }

  public post(url: string, data: any, elements: string = null, handleError: boolean = true): Observable<any> {


    let isLoading = false;
    let timeOut = null;
    let contentType = true;
    if (elements) {
      this.spinnerService.show(url, elements);
    } else {
      timeOut = setTimeout(() => {
        this.spinnerService.show(url, elements);
        isLoading = true;
      }, 1000);
    }

    let operationName = null;
    let viewCode = null;

    data.Params = null;
    operationName = data.OperationName;
    viewCode = data.Source;

    if (data.Files && data.Files.length > 0) {
      contentType = false;

      let formData = new FormData();

      for (let file of data.Files)
        formData.append('files', <File>file);
      data.Files = null;
      formData.set('postData', JSON.stringify(data));
      data = formData;
    }
    else if (url.indexOf('ReportService') > 0) {
      operationName = data.Code;
      viewCode = data.Source;
    }
    let headers = this.getHeadears(contentType);

    return this.http.post(url, data, { observe: 'response', headers: headers }).pipe(
      map(x => this.extractData(x)),
      catchError((error: Response | any) => {
        return this.handleResponseError(error, 'post', url, null, handleError)
      }),
      finalize(() => {
        if (isLoading && !elements) {
          this.spinnerService.hide(url);
        } else if (elements) {
          this.spinnerService.hide(url, elements);
        } else {
          clearTimeout(timeOut);
        }
      }));
  }

  public get(url: string, elements: string = null, handleError: boolean = true): Observable<any> {

    let headers = this.getHeadears();

    let isLoading = false;
    let timeOut = null;
    /*if (elements) {
      this.spinnerService.show(url, elements);
    } else {*/
    timeOut = setTimeout(() => {
      this.spinnerService.show(url, elements);
      isLoading = true;
    }, 1000);
    //}{observe: 'response', headers: 'autorization'}

    return this.http.get(url, { observe: 'response', headers: headers }).pipe(
      map(x => this.extractData(x)),
      catchError((error: Response | any) => {
        return this.handleResponseError(error, 'get', url, null, handleError)
      }),
      finalize(() => {
        if (isLoading && !elements) {
          this.spinnerService.hide(url);
        } else if (elements) {
          this.spinnerService.hide(url, elements);
        } else {
          clearTimeout(timeOut);
        }
      }));
  }

  public put(url: string, data: any, elements: string = null, handleError: boolean = true): Observable<any> {

    let headers = this.getHeadears();

    let isLoading = false;
    let timeOut = null;
    if (elements) {
      this.spinnerService.show(url, elements);
    } else {
      timeOut = setTimeout(() => {
        this.spinnerService.show(url, elements);
        isLoading = true;
      }, 1000);
    }

    let operationName = null;
    let viewCode = null;

    if (data instanceof ServicePlus) {
      operationName = data.OperationName;
      viewCode = data.Source;
    }
    else if (url.indexOf('ReportService') > 0) {
      operationName = data.Code;
      viewCode = data.Source;
    }

    return this.http.put(url, data, { observe: 'response', headers: headers }).pipe(
      map(x => this.extractData(x)),
      catchError((error: Response | any) => {
        return this.handleResponseError(error, 'put', url, null, handleError)
      }),
      finalize(() => {
        if (isLoading && !elements) {
          this.spinnerService.hide(url);
        } else if (elements) {
          this.spinnerService.hide(url, elements);
        } else {
          clearTimeout(timeOut);
        }
      }));
  }

  public delete(url: string, elements: string = null, handleError: boolean = true): Observable<any> {

    let headers = this.getHeadears();

    let isLoading = false;
    let timeOut = null;
    if (elements) {
      this.spinnerService.show(url, elements);
    } else {
      timeOut = setTimeout(() => {
        this.spinnerService.show(url, elements);
        isLoading = true;
      }, 1000);
    }

    return this.http.delete(url, { observe: 'response', headers: headers }).pipe(
      map(x => this.extractData(x)),
      catchError((error: Response | any) => {
        return this.handleResponseError(error, 'delete', url, null, handleError)
      }),
      finalize(() => {
        if (isLoading && !elements) {
          this.spinnerService.hide(url);
        } else if (elements) {
          this.spinnerService.hide(url, elements);
        } else {
          clearTimeout(timeOut);
        }
      }));
  }

  public scheduleRequest(method: string, url: string, callback: (response: any) => void, fallback: (error: Error) => void = null, data: any = null, elements: string = null, isAsync: boolean = false, cacheName: string = null): number {
    let mainRequest: (url: string, data?: any, elements?: string) => Observable<any>;
    let requestArgs: QueueRequestArgs = {
      requestUrl: url,
      postData: data,
      source: elements,
      onSuccess: callback,
      onFail: fallback,
      isAsync: isAsync
    };

    if (method === 'post')
      mainRequest = (_url, _data, _elements) => this.post(_url, _data, _elements);
    else if (method === 'get')
      mainRequest = (_url, _data, _elements) => this.get(_url, _elements);
    else
      throw new Error('Invalid http method');

    return this.requestQueueService.queueRequest(mainRequest, requestArgs, cacheName);
  }

  private extractData(res: any) {
    let newtoken = res.headers?.get("Token");

    if (newtoken) {
      this.token.access_token = newtoken;
      this.loggedUserStore.dispatch(new SaveLoggedUserAction(this.token));
    }

    return res?.body ? res.body : res;

  }

  public handleResponseError(error, type, url, data = null, handleError) {
    if (url)
      this.spinnerService.hide(url);

    if (error.status === 401) {//If unauth retry loggin
      this.loggedUserStore.dispatch(new ClearLoggedUserAction());
      this.router.navigateByUrl('/login');
      return throwError(new PlusException('Estimado(a) asociado(a), su sesión ha expirado, favor volver a iniciar sesión.', 'SESSION_EXPIRED'));
    } else {
      /*Setea el nuevo token si lo trae*/
      let newtoken = error?.headers?.get("Token");
      if (newtoken) {
        this.token.access_token = newtoken;
        this.loggedUserStore.dispatch(new SaveLoggedUserAction(this.token));
      }
      /*Setea el nuevo token si lo trae*/
      if (handleError) {
        error = error?.error ? error.error : error;
        let errorMsg = (error.ResponseMessages && error.ResponseMessages.length > 0 ? error.ResponseMessages[0].Message : error.description) || null
        // errorMsg = errorMsg ? errorMsg : (error.responseMessages && error.responseMessages.length > 0 ? error.responseMessages[0].message : error.description) || null;
        let errorCode = (error.ResponseMessages && error.ResponseMessages.length > 0 ? error.ResponseMessages[0].MessageCode : error.code) || null
        return throwError(new PlusException(errorMsg, errorCode));
      } else {
        return null
      }
    }
  }

  private getMethodToExecute(type, url, data = null): Observable<any> {
    switch (type) {
      case 'post':
        return this.post(url, data, '');
        break;
      case 'get':
        return this.get(url)
        break;
      case 'put':
        return this.put(url, data, '');
        break;
      case 'delete':
        return this.delete(url);
        break;
      default:
        return throwError(new PlusException('Unsupported HTTP verb', 'HS-0270'));
    }
  }

  public postCustom(url, body, options, spinner = true, handleError = true): Observable<any> {
    if (spinner)
      this.spinnerService.show(url);

    options.observe = 'response';

    return this.http.post(url, body, options).pipe(
      map(x => this.extractData(x)),
      catchError((error: Response | any) => {
        if (handleError)
          return this.handleResponseError(error, 'delete', url, null, handleError)
        else
          return null
      }),
      finalize(() => {
        this.spinnerService.hide(url);
      }));
  }

  private getHeadears(contentType = true) {
    let headers;

    if (!this.useApikey) {
      let token = this.token?.access_token ? this.token.access_token : '';
      headers = {
        'Authorization': 'bearer ' + token
      }
    } else {
      headers = {
        'x-api-key': HttpService.APIKEY
      }
    }

    if (contentType) {
      headers['Content-Type'] = 'application/json; charset=utf-8';
    }

    return new HttpHeaders(headers);
  }

}

